import React from 'react';
import PropTypes from 'prop-types';
import 'moment-timezone';
import moment from 'moment';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import { LocationMap } from '../../';
import Loader from '../../Loader';
import _ from 'lodash';

const propTypes = {
  loading: PropTypes.bool.isRequired,
  currentItem: PropTypes.object.isRequired,
};

const defaultProps = {
  loading: true
};

const CamPanel = (props) => {

  const { openState, loading } = props;
  const {
    description: camDescription,
    best_viewing_start_time: bestViewingStart,
    best_viewing_end_time: bestViewingEnd,
    established_date: camEstablishedDate,
    latlong: location,
    prime_all_day: allDay,
    prime_all_night: allNight,
  } = props.currentItem;
  let { location_text: locationText } = props.currentItem;
  const camTimeZone = _.get(props.currentItem, 'weather.current.timezone');

  const userTimezone = moment.tz.guess();
  const formattedStart = moment.tz(bestViewingStart, 'HH:mm:ss', camTimeZone).format();
  const formattedEnd = moment.tz(bestViewingEnd, 'HH:mm:ss', camTimeZone).format();

  let primeHoursAll = false;
  let primeHoursText = '';
  if (allDay || allNight) {
    primeHoursAll = true;
    if (allDay) primeHoursText = 'All Day';
    if (allDay && allNight) primeHoursText += ' and ';
    if (allNight) primeHoursText += 'All Night'
  }

  if (!locationText) locationText = '';
  const locationPieces = locationText.split(/,(.+)/);
  const locationDisplay = (locationPieces.length > 1) ? `${locationPieces[0]}<br />${locationPieces[1]}` : locationText;

  return (
    <div className={`widget panel cam ${loading ? 'loading' : ''}`}>
      {
        loading ?
        <Loader dark fill /> :
        <div>
          <div className="plr-30 pt-30 text-justify" dangerouslySetInnerHTML={{__html: camDescription}} />

            <div className="text-center mt-20 d-flex plr-30">
              {
                bestViewingStart && bestViewingEnd && bestViewingStart != '00:00:00' && bestViewingEnd != '00:00:00' && !primeHoursAll &&
                <div className="prime-viewing-hours">
                  <span className="text-uppercase u-font-foundation-bold u-textSize-18">Live Viewing Hours</span>
                  <br />
                  <span className="u-font-foundation-roman u-textSize-18">
                    <Moment format="h:mm" tz={userTimezone}>{formattedStart}</Moment>
                    <span className="smaller-text">&nbsp;<Moment format="A" tz={userTimezone}>{ formattedStart }</Moment></span> - <Moment format="h:mm" tz={userTimezone}>{formattedEnd}</Moment>
                    <span className="smaller-text">&nbsp;<Moment format="A z" tz={userTimezone}>{ formattedEnd }</Moment></span>
                  </span>
                </div>
              }
              {
                primeHoursAll &&
                <div className="prime-viewing-hours">
                  <span className="text-uppercase u-font-foundation-bold u-textSize-18">Live Viewing Hours</span>
                  <br />
                  <span className="u-font-foundation-roman u-textSize-18">
                    <span className="u-font-foundation-roman u-textSize-18">{primeHoursText}</span>
                  </span>
                </div>
              }
              {
                camEstablishedDate != null && camEstablishedDate != 'null' && camEstablishedDate != '' &&
                <div className="cam-established">
                  <span className="text-uppercase u-font-foundation-bold u-textSize-18">Established</span>
                  <br />
                  <span className="u-font-foundation-roman u-textSize-18">{camEstablishedDate}</span>
                </div>
              }
            </div>

            <div className="plr-10">
              {
                location && openState ?
                <LocationMap lat={location[0]} lng={location[1]}/>
                : <br/>
              }
            </div>

            <div className="u-font-foundation-roman u-textSize-18 pb-20 text-center text-upper">
              {
                locationText.split(/,(.+)/).map( (i, index) => {
                  if (i.length === 0) return;
                  return (index === 0) ?
                    <span key={index}>{i}<br/></span> :
                    <span key={index}>{i}</span>;
                })
              }
            </div>

          </div>
      }
    </div>
  );

}

CamPanel.propTypes = propTypes;
CamPanel.defaultProps = defaultProps;

export default CamPanel;
